export const visit = (vm, at) => {
at({ "en": { "ConversationsInboxUIAttachments": { "threadPreviewText": "An attachment has been sent", "fileUploads": { "uploadProgress": "{{uploadedBytes}} of {{totalBytes}}" } } } });
};